import React from 'react';
import { ArrowRightIcon, LockKeyholeIcon, ShieldCheckIcon } from 'lucide-react';
interface ActionButtonProps {
  children: React.ReactNode;
  href?: string;
  showTrust?: boolean;
  className?: string;
}
export const checkoutUrl = 'https://pack-historia-medica-en-orden.impultienda.ar/checkout';
export function ActionButton({
  children,
  href = checkoutUrl,
  showTrust = false,
  className = ''
}: ActionButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (href !== '#pricing') return;
    event.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <div className={className} data-id="element-12" data-mp="2qnbsy7tvcy6q">
      <a href={href} onClick={handleClick} className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-green px-6 py-4 text-center font-display text-base font-bold text-white shadow-[0_8px_28px_rgba(22,163,74,0.26)] transition-colors duration-150 ease-out hover:bg-brand-light hover:text-brand-ink sm:text-lg" data-id="element-13" data-mp="2qm0n82gv5gcz">
        {children}
        <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-14" data-mp="2b279sgsh6he1" />
      </a>
      {showTrust && <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-slate-400" data-id="element-15" data-mp="2g23hor4amsyv">
          <span className="inline-flex items-center gap-1.5" data-id="element-16" data-mp="2kzvhs8f3dle5"><ShieldCheckIcon className="h-3.5 w-3.5 text-brand-light" aria-hidden="true" data-id="element-17" data-mp="1ndel95e6nbtg" />Garantía 7 días</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-18" data-mp="1sb6ec2qkd3z8"><LockKeyholeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-19" data-mp="1s9vak2x4bw84" />Pago seguro</span>
          <span data-id="element-20" data-mp="1x9rey39q9po7">Mercado Pago</span>
        </div>}
    </div>;
}